export const freePlan = {
  title: "You're on a Free Plan",
  infoMessage: "Unlock more features with a Premium Plan! Subscribe now",
  description:
    "You're currently using the basic free plan, which comes with limited access to profiles and features. Upgrade to a premium plan to enjoy",
  planFeature: [
    "Unlimited messaging – Connect freely without any restrictions.",
    "Profile boost – Get more visibility and attract potential matches.",
    "View full profiles – Access complete details of your matches.",
    "Matchmaker insights – Receive expert recommendations tailored for you.",
    "Priority support – Get dedicated assistance whenever you need it.",
  ],
};

export const whyChooseSubscription = [
  [
    "Get one-on-one assistance from a matchmaking expert.",
    "Receive carefully curated matches tailored to your preferences.",
    "Stand out with a featured profile for better visibility.",
    "Let our experts refine your search for the best matches.",
    "Increase trust with verified badges and authentic connections.",
    "Connect with shortlisted profiles directly.",
  ],
  [
    "Get priority visibility to reach more potential matches.",
    "Send unlimited messages and connect freely.",
    "View contact details of interested profiles.",
    "Video & voice calls for deeper connections.",
    "Access premium badges to stand out from the crowd.",
    "Ad-free experience for uninterrupted browsing.",
  ],
];
